import { render } from "./App.vue?vue&type=template&id=463e3b9e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=463e3b9e&lang=css"

import exportComponent from "/Users/tony/argon2/vue-argon-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__